import { Component } from "@angular/core"
import { AlertController, LoadingController, ViewController, NavParams } from "ionic-angular"

import firebase from "firebase"

declare var document: any

@Component({
  selector: "profile-picture-page",
  templateUrl: "picture.html",
})
export class ProfilePicturePage {

  picture = ""
  showUpdateButton = false
  loading: any = null

  slimOptions = {
    instantEdit: true,
    dataPush: true,
    service: this.onUpload.bind(this),
    serviceFormat: "file",
    didConfirm: this.onConfirm.bind(this),
    label: "Clique aqui para escolher uma foto",
    buttonRemoveTitle: "Remover",
    buttonEditTitle: "Editar",
    buttonUploadTitle: "Enviar",
    buttonCancelLabel: "Cancelar",
    buttonConfirmLabel: "Confirmar",
    statusFileType: "Selecione um arquivo de imagem",
    statusUploadSuccess: '<span class="slim-upload-status-icon"></span> Foto atualizada',
    statusUnknownResponse: '<span class="slim-upload-status-icon"></span> Falha ao enviar imagem',
    minSize: {
      width: 70,
      height: 70,
    },
  }

  constructor(
    private alertCtrl: AlertController,
    private loadingCtrl: LoadingController,
    private viewCtrl: ViewController,
    private navParams: NavParams
  ) {

    this.picture = this.navParams.get("user").picture
    this.loading = this.loadingCtrl.create({ content: "Por favor, aguarde..." })
  }

  onCancel() {

    this.viewCtrl.dismiss()
  }

  onConfirm() {

    this.showUpdateButton = true
  }

  onUpdateButtonClick() {

    this.loading.present()

    const elements = document.getElementsByClassName("slim-btn-upload")

    elements[0].click()
  }

  onUpload(data, progress, success, failure) {

    this.loading.present()

    const image = data[0]
    const loggedUser = firebase.auth().currentUser

    firebase.storage().ref(`user-pictures/${loggedUser.uid}.jpg`).put(image)
      .then((snapshot) => {

        this.picture = snapshot.metadata.downloadURLs[0]

        return firebase.database().ref(`users/${loggedUser.uid}`)
          .update({ picture: this.picture })
      })
      .then(() => {

        this.loading.dismiss()
        this.viewCtrl.dismiss(this.picture)
      })
      .catch((error) => {

        console.log(error)

        this.loading.dismiss()

        this.alertCtrl.create({
          message: "Falha ao atualizar foto do perfil",
          buttons: ["Ok"]
        }).present()
      })
  }
}



// WEBPACK FOOTER //
// ./src/pages/profile/picture.ts